import { Link } from "react-router-dom";
import { timelineSpotlight } from "@/mocks/site";
import { cases } from "@/mocks/cases";

const kindTone: Record<string, { dot: string; label: string }> = {
  claim: { dot: "bg-accent-500", label: "初始指控" },
  spread: { dot: "bg-secondary-500", label: "扩散阶段" },
  response: { dot: "bg-primary-600", label: "当事方回应" },
  turn: { dot: "bg-accent-600", label: "关键转向" },
  clarify: { dot: "bg-primary-800", label: "澄清落地" },
};

const spotlight = cases[0];

export default function FocusSection() {
  return (
    <section id="focus" className="scroll-mt-12 w-full border-b border-background-200 bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-5">
            <p className="text-[11px] font-medium tracking-[0.24em] text-secondary-500">CASE OF THE WEEK</p>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              重点反转：一次被修正的定性
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              这起事件在 48 小时内经历了两轮方向变化：先是几乎一边倒的指责，随后关键材料出现，
              公众判断被迫重新校准。它几乎包含了所有典型要素——片段化材料、情绪化标签、
              滞后的回应，以及一份迟到的原始证据。
            </p>

            <div className="mt-6 rounded-lg border border-background-300 bg-background-50 p-4 md:p-5">
              <h3 className="font-heading text-sm font-semibold text-foreground-950">争议焦点</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{spotlight.focus}</p>
              <h3 className="mt-5 font-heading text-sm font-semibold text-foreground-950">归档结论</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{spotlight.verdict}</p>
            </div>

            <Link
              to={`/cases/${spotlight.slug}`}
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-foreground-900 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800"
            >
              <i className="ri-book-open-line text-base" aria-hidden="true" />
              阅读完整档案
            </Link>
          </div>

          <div className="lg:col-span-7">
            <ol className="relative border-l border-background-300 pl-6 md:pl-8">
              {timelineSpotlight.map((node, index) => {
                const tone = kindTone[node.kind] ?? kindTone.claim;
                return (
                  <li key={node.title} className={`relative ${index === timelineSpotlight.length - 1 ? "" : "pb-8"}`}>
                    <span
                      className={`absolute -left-[calc(1.5rem+5px)] top-1.5 h-2.5 w-2.5 rounded-full ring-4 ring-background-100 md:-left-[calc(2rem+5px)] ${tone.dot}`}
                      aria-hidden="true"
                    />
                    <div className="flex flex-wrap items-center gap-3">
                      <time className="font-heading text-xs font-semibold tracking-wide text-foreground-700">
                        {node.time}
                      </time>
                      <span className="rounded-full bg-background-200 px-2.5 py-0.5 text-[10px] font-medium text-foreground-700">
                        {tone.label}
                      </span>
                    </div>
                    <h3 className="mt-2 font-heading text-base font-semibold text-foreground-950">{node.title}</h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{node.detail}</p>
                  </li>
                );
              })}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}